import React from 'react'

export default function Tablet() {
    return (
        <div>
            <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M140 29.1667C140 22.7267 134.773 17.5 128.333 17.5H11.6667C5.22667 17.5 0 22.7267 0 29.1667V110.833C0 117.273 5.22667 122.5 11.6667 122.5H128.333C134.773 122.5 140 117.273 140 110.833V29.1667ZM122.5 110.833H17.5V29.1667H122.5V110.833ZM131.25 72.9167C129.64 72.9167 128.333 71.61 128.333 70C128.333 68.39 129.64 67.0833 131.25 67.0833C132.86 67.0833 134.167 68.39 134.167 70C134.167 71.61 132.86 72.9167 131.25 72.9167Z" fill="black" />
            </svg>
        </div>
    )
}
